"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentPartVersionSchemaVersion = exports.getSchemaVersion = exports.PartVersionSchemaVersion = exports.StaticPartVersionDescriptorSchema = void 0;
const zod_1 = require("zod");
const schema_1 = require("../schema");
/**
 * Part versions that never change are called static part versions. Once they are created, they are never modified or destroyed.  They are
 * uniquely identified by three pieces of data: a part uid to which the version belongs, a part version, which represents a snapshot in time of
 * the state of the part in question, and a schema tag that specifies how the data itself is laid out.
 */
exports.StaticPartVersionDescriptorSchema = zod_1.z.object({
    partUid: zod_1.z.string(),
    partVersion: zod_1.z.string().or(zod_1.z.literal("latest")),
    /**
     * Optional parameter that points to a _specific_ schema version within the part.
     * @remarks Generally should not be needed - avoid unless you know what you're doing.
     */
    schemaTag: zod_1.z.string().optional(),
});
var PartVersionSchemaVersion;
(function (PartVersionSchemaVersion) {
    /**
     * Version 0 corresponds to compressing the extracted_element_cache and pcbLayoutNodes
     * to achieve a reduction in the size of the IPartVersionData at rest.
     */
    PartVersionSchemaVersion[PartVersionSchemaVersion["compressedElementsAndNodes"] = 0] = "compressedElementsAndNodes";
    /**
     * Version 1 corresponds to additionally support link in prop value
     */
    PartVersionSchemaVersion[PartVersionSchemaVersion["linkPropValue"] = 1] = "linkPropValue";
})(PartVersionSchemaVersion || (exports.PartVersionSchemaVersion = PartVersionSchemaVersion = {}));
const getSchemaVersion = (data) => {
    if (data[schema_1.schemaVersionKey] === undefined)
        return undefined;
    const versionKey = data[schema_1.schemaVersionKey];
    const schemaVersion = PartVersionSchemaVersion[PartVersionSchemaVersion[versionKey]];
    return schemaVersion;
};
exports.getSchemaVersion = getSchemaVersion;
/**
 * The schema version to write all new data with.
 */
exports.currentPartVersionSchemaVersion = PartVersionSchemaVersion.linkPropValue;
//# sourceMappingURL=schema.js.map